module.exports = __webpack_public_path__ + "img/collection-engagementRingsPrincess.77b04a9.webp";